import { type Models } from '@rematch/core';
import cache from './cache';
import compare from './compare';
import filters from './filters';
import ui from './ui';

export type RootModel = Models<RootModel> & {
  cache: typeof cache;
  compare: typeof compare;
  filters: typeof filters;
  ui: typeof ui;
};

const models: RootModel = { cache, compare, filters, ui };

export default models;
